import React from 'react';
import { Segment, Divider, Button, List, Icon, Form, Message, Checkbox, Input } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { PANELCHANGER_BASEURL } from '../../constants/system'
import { history } from '../../store';

/**
 * Add address component
 */
export default class AddAddress extends React.Component {

	/**
     * Constructor
     * @param {*} props 
     */
    constructor(props) {
        super(props);

        this.state = {
		}
	}		

	componentDidMount() {
		this.props.clearAddressUi();
		this.props.clearRequestUi();
		this.props.clearTargetUi();

		document.getElementById('addAddress.city').focus();

		this.props.fetchTargetAddresses(this.props.match.params.license);
		this.props.fetchTarget(this.props.match.params.license);

		let hcoList = [];

		fetch('/hcoList.json').then(response => response.json()).then(data => {

			const temp = data.map(hco => {
				return Object.values(hco)[0];
			});

			hcoList = [...new Set(temp.map(item => item))];

			// Local HCO list
			this.setState({
				...this.state,
				hcoList: hcoList.map( hco => {
					return {
						key: hco,
						text: hco,
						value: hco
					}
				})
			})			

		}).catch(error => { alert('Hiba! ' + error); console.error(error) });

	}

	componentWillUnmount() {
		this.props.clearAddressUi();
		this.props.clearRequestUi();
		this.props.clearTargetUi();
	}

	/**
	 * Filter addresses
	 * @param {*} e 
	 */
	handleTargetFiltering(e) {
		const city = document.getElementById('addAddress.city').value;
		const postalCode = document.getElementById('addAddress.postalCode').value;
		const hco = document.getElementById('addAddress.hco').value;
		let address = document.getElementById('addAddress.address').value;
		if (address.length > 2 || city.length > 2 || postalCode.length > 2 || hco.length > 2)
		{
			this.props.fetchAddresses(city, postalCode, encodeURIComponent(address), encodeURIComponent(hco));
		}
	}

	/**
	 * Creates a concatenated address from city, postal code and address.
	 */
	createConcatenatedAddress = (address) => {
		return address.city + address.postalCode + address.address;
	}

	/**
	 * Set primary address for that target in the relation of that visitor
	 */
	setPrimaryAddress = (address) => {
		const concatAddress = this.createConcatenatedAddress(address);
		const license = this.props.match.params.license;
		const visitorTerritory = this.props.visitorTerritory;

		fetch(PANELCHANGER_BASEURL + '/target/' + license + '/address/' + visitorTerritory + '/primary', { method: 'POST', body: JSON.stringify({ concatAddress }), headers: { 'Token': localStorage.getItem('token') }}).then(data => {
			alert('Sikeres elsődleges cím mentés');
		}).catch(error => { alert('Hiba! ' + error); console.error(error) });		
	}

	addAddress = (a, index) => {
		const hco = document.getElementById('address.hco' + index).value;
		console.log({hco});
		if (hco !== '' && hco !== undefined)
		{
			this.props.addAddressToPanel(this.props.visitorTerritory, this.props.target.license, a.city, a.postalCode, a.address, hco);
		}
		else
		{
			alert('A választott címhez tartozó intézmény megadása kötelező.');
		}
	}

	render() {
		return  <Segment basic loading={ this.props.isLoadingTarget || this.props.isSaving }>
                    { this.props.errorTarget === undefined ? '' : <Message error>Hiba történt. { this.props.errorTarget }</Message> }
                    { this.props.errorAddress === undefined ? '' : <Message error>Hiba történt. { this.props.errorAddress }</Message> }
                    { this.props.errorRequest === undefined ? '' : <Message error>Hiba történt. { this.props.errorRequest }</Message> }
                    { this.props.errorConsent === undefined ? '' : <Message error>Hiba történt. { this.props.errorConsent }</Message> }
					<h3><Icon name='plus'/>Célpont címei</h3>
					<h4>{ this.props.target.name }</h4>
					<Divider/>
					Ismert címei:
					<br/>
					<br/>
					<table width="100%">
					{
						this.props.addressesByLicense.length > 0 ?
						this.props.addressesByLicense.map( (a, index) => {
							return <tr key={ index }>
								<td width={1}>
									<Checkbox defaultChecked={a.isPrimary} style={{ marginTop: '8px' }} toggle onChange={ (e) => { this.setPrimaryAddress(a); history.push('/'); } }/> 
								</td>
								<td>
									<Icon name='home'/> <b>{ a.city }</b>, { a.postalCode }, { a.address }
								</td>
								<td>
									Intézmény: <b>{ a.hco === null || a.hco === '' ? 'még nincs megadva' : a.hco }</b>
								</td>
							</tr>
						})
						:
						''
					}
					</table>
					<br/>
					<b>Elsődleges cím</b> beállításához kattints a cím előtti csúszkára.
					<br/>
					Keresd meg a központ által ismert címek közül azt, amelyiket még hozzá szeretnéd rendelni:
					<Divider/>
					<Form>
						<Form.Group widths='equal'>
							<Form.Input
								id='addAddress.city'
								fluid
								label='Település neve'
								placeholder='Település neve vagy névtöredéke'
							/>
							<Form.Input
								id='addAddress.postalCode'
								fluid
								label='Irányítószám'
								placeholder='Irányítószám vagy csak egy része'
							/>
							<Form.Input
								id='addAddress.address'
								fluid
								label='Cím, házszám'
								placeholder='Cím töredéke vagy teljes cím'
							/>
							<Form.Input
								id='addAddress.hco'
								fluid
								label='Intézmény (HCO)'
								placeholder='Intézmény neve vagy töredéke'
							/>							
							<Form.Button style={{ marginTop: '24px' }} disabled={ this.props.isLoadingAddresses || this.props.isSaving } floated='right' primary onClick={ (e) => this.handleTargetFiltering(e) } icon>
								<Icon name='zoom'/> Keresés
							</Form.Button>
						</Form.Group>
					</Form>
					{
						this.props.isLoadingAddresses
						?
						<span>Keresés...</span>
						:
						<span>Felvehető címek: <b>{ this.props.addresses.length }</b> cím.</span>
					}
					<List divided relaxed='very' verticalAlign='middle'>
					{
						this.props.addresses.map( (a, index) => {
							if (a.license !== this.props.match.params.license)
							{
								return <List.Item key={ index }>
											<List.Content floated='right'>
												<Button disabled={ this.props.isSaving } onClick={ () => { this.addAddress(a, index) } } icon color='green'><Icon name='plus'/> Célponthoz ad</Button>
											</List.Content>
											<List.Content>
												<b>{ a.city }</b>, { a.postalCode }, { a.address }
												<br/>
												<span style={{ marginRight: "12px" }}>Intézmény</span>
												<Input style={{ width: '100%' }} id={ 'address.hco' + index } placeholder='Intézmény az adott címen' defaultValue={ a.hco } required />
											</List.Content>
										</List.Item>
							}
							else
							{
								return '';
							}
						}, this)
					}
					</List>
					<Divider/>
					<Link to='/panelChanges'><Button basic primary>Vissza</Button></Link>
				</Segment>
	}
}